import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';

import { ReactComponent as MoreIcon } from '@src/assets/escher/icons/expand-less.svg';
import { ReactComponent as LessIcon } from '@src/assets/escher/icons/expand-more.svg';

const ExpandIndicator = styled.span`
  float: right;
  margin-top: 3px;
`;

const Secondary = styled.td`
  padding-top: 15px;
  color: ${props => props.theme.enigmaDarkGrey};
  line-height: 28px;
  font-size: 16px;
`;

const MaxWidth = styled.td`
  width: 100%;
  vertical-align: middle;
`;

const ScoreNegative = styled.span`
  margin-right: 16px;
  color: ${props => props.theme.valid};
  font-family: 'GT Mono', monospace;
`;

const ScorePositive = styled(ScoreNegative)`
  color: ${props => props.theme.invalid};
`;

const Container = styled.div`
  border-top: ${props => props.theme.borderMd};
  width: 100%;
  padding-top: 10px;
  margin-top: 20px;
  min-height: 70px;
  display: inline-block;
`;

function HitFeature({ description, reason, value }) {
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = e => {
    e.preventDefault();
    setExpanded(!expanded);
  };

  const ScoreContainer = value > 0 ? ScorePositive : ScoreNegative;
  return (
    <Container>
      <table>
        <tbody>
          <tr onClick={toggleExpanded}>
            <td>
              <ExpandIndicator>
                {expanded ? <MoreIcon /> : <LessIcon />}
              </ExpandIndicator>
            </td>
            <MaxWidth>{reason}</MaxWidth>
            <td>
              <ScoreContainer>
                {value > 0 ? '+' : '-'}&nbsp;
                {Math.abs(value).toFixed(4)}
              </ScoreContainer>
            </td>
          </tr>
          {expanded && (
            <tr>
              <td></td>
              <Secondary>{description}</Secondary>
            </tr>
          )}
        </tbody>
      </table>
    </Container>
  );
}

HitFeature.propTypes = {
  reason: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
};

export default HitFeature;
